var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-tabs', {
    attrs: {
      "nav-class": "v-nav",
      "pills": "",
      "vertical": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Frameset",
      "active": ""
    }
  }, [_c('Product', {
    attrs: {
      "user-gems": _vm.userGems,
      "user-coins": _vm.userCoins,
      "products": _vm.frames
    },
    on: {
      "activateModalChild": _vm.activateModalChild
    }
  })], 1), _c('b-tab', {
    attrs: {
      "title": "Wheel"
    }
  }, [_c('Product', {
    attrs: {
      "products": _vm.wheels,
      "user-gems": _vm.userGems,
      "user-coins": _vm.userCoins
    },
    on: {
      "activateModalChild": _vm.activateModalChild
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }